import React from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML, titleize } from 'underscore.string';
import CargomaticCard from 'components/v2/card';
import Badge from '../../../v2/Badge';
import 'utils/selectize';
import { Avatar } from '../Avatar';
const ConsigneeProfileCard = ({ consignee }) => {
    const { authorized, _id } = consignee;
    const { t } = useTranslation();
    return (React.createElement(CargomaticCard, { className: "mb-6" },
        React.createElement("div", { className: "text-center" },
            React.createElement("div", { className: "flex justify-center py-6" },
                React.createElement(Avatar, { key: _id, userId: _id, className: "h-32 w-32 cursor-pointer rounded-full" })),
            React.createElement("div", { className: "flex flex-wrap justify-center items-center gap-x-2 gap-y-2 " },
                React.createElement(Badge, { color: "pink" }, t('CONSIGNEE')),
                authorized ? (React.createElement(Badge, { color: "green" }, titleize(t('AUTHORIZED')))) : (React.createElement(Badge, { color: "red" }, t('UNAUTHORIZED')))),
            React.createElement("h3", { className: "my-2 text-xl text-grey-darker" }, unescapeHTML(consignee === null || consignee === void 0 ? void 0 : consignee.company_name)))));
};
export default ConsigneeProfileCard;
